import CachedIcon from "@mui/icons-material/CachedRounded";
import LocalShippingIcon from "@mui/icons-material/LocalShippingRounded";
import { Box, Typography } from "@mui/material";
import { useContainer, useTemplate } from "containers/templateDetail/store";
import head from "lodash/head";
import * as React from "react";
import { useTemplateShippingProfiles } from "services/template";
import { SelectButton, SelectValue } from "./index";

export default function ShippingProfileSelect(): React.ReactElement {
  const { id: templateID } = useTemplate();
  const { data: shippingProfiles } = useTemplateShippingProfiles({
    id: templateID,
  });

  const [activeCountryCode] = useContainer.activeCountryCode();
  const [activeShippingProfileID] = useContainer.activeShippingProfileID();

  const activeShippingProfile = React.useMemo(() => {
    return shippingProfiles?.find(
      (item) => item.id === activeShippingProfileID
    );
  }, [shippingProfiles, activeShippingProfileID]);

  const [, setOpen] = useContainer.isSwitchModalOpen();
  const handleOpen = () => {
    setOpen(true);
  };

  const minShippingTime = React.useMemo(() => {
    if (activeShippingProfile?.type === "DROP_SHIPPING") {
      return head(activeShippingProfile.rates)?.min_shipping_time || 0;
    }

    if (activeShippingProfile?.type === "BULK_SHIPPING") {
      return (
        activeShippingProfile?.gram_prices.find(
          (item) => item.country_code === activeCountryCode
        )?.min_shipping_time || "∞"
      );
    }

    return "∞";
  }, [activeCountryCode, activeShippingProfile]);

  const maxShippingTime = React.useMemo(() => {
    if (activeShippingProfile?.type === "DROP_SHIPPING") {
      return head(activeShippingProfile.rates)?.max_shipping_time || 0;
    }

    if (activeShippingProfile?.type === "BULK_SHIPPING") {
      return (
        activeShippingProfile.gram_prices.find(
          (item) => item.country_code === activeCountryCode
        )?.max_shipping_time || "∞"
      );
    }

    return "∞";
  }, [activeCountryCode, activeShippingProfile]);

  return (
    <Box sx={{ flex: 1, py: 2, px: 2 }} onClick={handleOpen}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: (theme) => theme.typography.fontWeightBold }}
      >
        {minShippingTime}&nbsp;⁠–&nbsp;
        {maxShippingTime}⁠ days
      </Typography>
      <SelectButton>
        <LocalShippingIcon />
        <SelectValue>{activeShippingProfile?.name}</SelectValue>
        <CachedIcon className="switch-icon" sx={{ ml: "auto", fontSize: 16 }} />
      </SelectButton>
    </Box>
  );
}
